import { render } from "./Footer.vue?vue&type=template&id=2801dd09&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=2801dd09&lang=css"
import "./Footer.vue?vue&type=style&index=1&id=2801dd09&scoped=true&lang=css"
import "./Footer.vue?vue&type=style&index=2&id=2801dd09&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2801dd09"]])

export default __exports__